<template>
    <div class="popup-row" id="logout">
        <div class="popup-Comment-row">
            <div class="Delete-Comment-row">
                <p>{{ $t('Log_out') }}</p>
                <div class="popup-Comment-btn">
                    <button @click="no">{{ $t('no') }}</button>
                    <button @click="logout">{{ $t('yes') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LogoutPopup",
    methods: {
        logout() {
            window.location.href = '/user/logout';
        },
        no() {
            jQuery("#logout").removeClass("active");
            jQuery("html, body").removeClass("filter_body");
        }
    }
}
</script>

<style scoped>

</style>
